import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { ApplicationState } from '~/store';
import { ResponseProps } from '../../../utils/helper';
import {
  companyFailure,
  companyRequest,
  companySuccess,
  signedFailure,
  signedRequest,
  signedSuccess,
  signFailure,
  signInRequest,
  signInSuccess,
  signOutFailure,
  signOutRequest,
  signOutSuccess,
} from './actions';
import { AuthTypes } from './types';

function* signIn({ payload }: ReturnType<typeof signInRequest>) {
  const { code } = payload;
  const { company } = yield select((state: ApplicationState) => state.auth);

  try {
    const response: ResponseProps = yield call(
      api.post,
      `/v1/auth/token?code=${code}`,
      null,
      {
        headers: {
          'content-type': 'application/json',
          company: company?.country_company_id,
        },
      },
    );

    const token = response.data.access_token;

    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    yield put(signInSuccess(response.data));

    //@ts-ignore
    window.location.pathname = `/${company.path_alias_nm}/home`;
  } catch (error) {
    yield put(signFailure());
  }
}

function* signed({ payload }: ReturnType<typeof signedRequest>) {
  const { token, id_token, company } = yield select(state => state.auth);

  try {
    const response: ResponseProps = yield call(
      api.get,
      '/v1/auth/userlgpdinfo',
      {
        headers: {
          auth: `${token}`,
          company: company?.country_company_id,
        },
      },
    );

    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    yield put(signedSuccess(token, response.data));
  } catch (error) {
    yield put(signedFailure());
  }
}

function* signOut({ payload }: ReturnType<typeof signOutRequest>) {
  const { id_token, company } = yield select(state => state.auth);

  try {
    yield put(signOutSuccess());

    //@ts-ignore
    yield (window.location = `https://idcs-f96a345674f4402caf09ebc240518ba4.identity.oraclecloud.com/oauth2/v1/userlogout?id_token_hint=${id_token}&post_logout_redirect_uri=${company?.oauth_admin_redirect_uri}`);
  } catch (error) {
    yield put(signOutFailure());
  }
}

function* company({ payload }: ReturnType<typeof companyRequest>) {
  const { company, code } = payload;
  console.log(company, 'company');

  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/company/alias?company=${company}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: '',
        },
      },
    );

    yield put(companySuccess(response.data));

    if (code) {
      yield put(signInRequest(code));
    }
  } catch (error) {
    //@ts-ignore
    yield (window.location = '/');
    yield put(companyFailure());
  }
}

export function setToken(payload: any) {
  if (!payload) return;

  if (!!payload?.payload?.auth?.token) {
    const { token } = payload.payload.auth;

    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }
}

export default all([
  takeLatest('persit/REHYDRATE', setToken),
  takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn),
  takeLatest(AuthTypes.SIGNED_REQUEST, signed),
  takeLatest(AuthTypes.SIGNOUT_REQUEST, signOut),
  takeLatest(AuthTypes.COMPANY_REQUEST, company),
]);
